import React, { lazy } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Accreditations from '../components/Accreditations';
const AboutPage = () => {
  return <div className="bg-white" data-id="element-352">
      <Helmet data-id="element-353">
        <title data-id="element-354">
          About Northampton Driving School | Local Driving Instructors
        </title>
        <meta name="description" content="Northampton Driving School specialises in automatic driving lessons. Learn more about our instructors, teaching style, and success rates." data-id="element-355" />
        <meta name="keywords" content="driving instructor Northampton, DVSA approved instructor, automatic driving lessons Northampton, driving school Northampton" data-id="element-356" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-357">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-358">About Us</h1>
        <h2 className="sr-only" data-id="element-359">
          DVSA Approved Driving Instructors Northampton
        </h2>
        <h2 className="sr-only" data-id="element-360">Qualified Automatic Driving School</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-361">
          <div data-id="element-362">
            <h2 className="text-2xl font-bold mb-4" data-id="element-363">Our Mission</h2>
            <p className="text-gray-700 mb-4" data-id="element-364">
              At <span className="text-burgundy-600" data-id="element-365">N</span>orthampton{' '}
              <span className="text-burgundy-600" data-id="element-366">D</span>riving{' '}
              <span className="text-burgundy-600" data-id="element-367">S</span>chool, we're dedicated
              to providing professional, patient, and reliable driving tuition
              in Northampton. Our mission is to help learners of all abilities
              gain confidence on the road through quality instruction, flexible
              scheduling, and competitive rates.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-368">
              We specialise in automatic car instruction, making the learning
              process smoother and less intimidating for new drivers. Our
              approach focuses on building practical skills and road awareness
              to ensure you become a safe, confident driver for life.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-369">
              Looking for faster results? Check out our{' '}
              <Link to="/intensive-lessons" className="text-burgundy-600 hover:text-burgundy-800 font-medium" aria-label="Learn more about our intensive driving courses" data-id="element-370">
                intensive driving courses Northampton
              </Link>{' '}
              designed to get you test-ready in less time.
            </p>
          </div>
          <div className="rounded-lg overflow-hidden shadow-md" data-id="element-371">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3g4uR3Hsch8qWkEegJDamW/about_us.png" alt="DVSA-approved driving instructor teaching student in automatic car Northampton" className="w-full h-full object-cover" loading="lazy" data-id="element-372" />
          </div>
        </div>
        <div className="mb-12" data-id="element-373">
          <h2 className="text-2xl font-bold mb-4" data-id="element-374">Our Approach</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-375">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-376">
              <h3 className="text-xl font-semibold mb-3" data-id="element-377">
                Patient Instruction
              </h3>
              <p className="text-gray-700" data-id="element-378">
                We understand that learning to drive can be stressful. Our
                instructors are selected for their patience and ability to
                create a calm, supportive learning environment.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-379">
              <h3 className="text-xl font-semibold mb-3" data-id="element-380">
                Personalised Learning
              </h3>
              <p className="text-gray-700" data-id="element-381">
                Everyone learns differently. We tailor our teaching methods to
                suit your individual learning style and pace, ensuring you make
                steady progress.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-382">
              <h3 className="text-xl font-semibold mb-3" data-id="element-383">
                Comprehensive Training
              </h3>
              <p className="text-gray-700" data-id="element-384">
                Beyond just passing the test, we focus on developing safe
                driving habits and road awareness that will serve you throughout
                your driving life.
              </p>
            </div>
          </div>
        </div>
        <div className="mb-12" data-id="element-385">
          <h2 className="text-2xl font-bold mb-4" data-id="element-386">Our Instructors</h2>
          <p className="text-gray-700 mb-6" data-id="element-387">
            Our instructors are DVSA approved and hold Approved Driving
            Instructor (ADI) qualifications. They undergo regular training to
            stay updated with the latest teaching methods and driving standards.
          </p>
        </div>
        <Accreditations data-id="element-388" />
        <div className="mt-12 text-center" data-id="element-389">
          <h2 className="text-2xl font-bold mb-4" data-id="element-390">
            Start Your Journey With Us
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-391">
            Whether you're a complete beginner or looking to polish your skills
            before your test, we're here to help you become a confident, safe
            driver.
          </p>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your first driving lesson in Northampton" data-id="element-392">
            Book Your First Lesson
          </a>
        </div>
      </div>
    </div>;
};
export default AboutPage;